import React, { useEffect, useState } from "react";
import InsightTable from "../InsightTable";
import { transformResultsToTableData } from "../../../../services/commonService";

function PerformanceAdoption({ performanceAndAdoption }) {
  const [tabData, setTabData] = useState([]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    { type: "conversation", title: "Conversation", onClick: () => {} },
    { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  // const dummyData = [
  //   {
  //     competitor: "a",
  //     customer_feedback: "b",
  //     market_adoption_rate: "c",
  //     performance_benchmarks: "d",
  //     customer_feedback_positive_insight: "b",
  //     customer_feedback_negative_insight: "b",
  //     customer_feedback_recent_development: "b",
  //     market_adoption_rate_positive_insight: "c",
  //     market_adoption_rate_negative_insight: "c",
  //     market_adoption_rate_recent_development: "c",
  //     performance_benchmarks_positive_insight: "d",
  //     performance_benchmarks_negative_insight: "d",
  //     performance_benchmarks_recent_development: "d",
  //   },
  //   {
  //     competitor: "a",
  //     customer_feedback: "b",
  //     market_adoption_rate: "c",
  //     performance_benchmarks: "d",
  //     customer_feedback_positive_insight: "b",
  //     customer_feedback_negative_insight: "b",
  //     customer_feedback_recent_development: "b",
  //     market_adoption_rate_positive_insight: "c",
  //     market_adoption_rate_negative_insight: "c",
  //     market_adoption_rate_recent_development: "c",
  //     performance_benchmarks_positive_insight: "d",
  //     performance_benchmarks_negative_insight: "d",
  //     performance_benchmarks_recent_development: "d",
  //   },
  //   {
  //     competitor: "a",
  //     customer_feedback: "b",
  //     market_adoption_rate: "c",
  //     performance_benchmarks: "d",
  //     customer_feedback_positive_insight: "b",
  //     customer_feedback_negative_insight: "b",
  //     customer_feedback_recent_development: "b",
  //     market_adoption_rate_positive_insight: "c",
  //     market_adoption_rate_negative_insight: "c",
  //     market_adoption_rate_recent_development: "c",
  //     performance_benchmarks_positive_insight: "d",
  //     performance_benchmarks_negative_insight: "d",
  //     performance_benchmarks_recent_development: "d",
  //   },
  // ];

  useEffect(() => {
    const tableData = transformResultsToTableData(performanceAndAdoption);
    setTabData(tableData);
  }, [performanceAndAdoption]);

  const tableColumns = [
    // { key: "competitor", label: "Competitor" },
    { key: "customer_feedback", label: "Customer Feedback" },
    { key: "market_adoption_rate", label: "Market Adoption Rate" },
    { key: "performance_benchmarks", label: "Performance Benchmarks" },
  ];

  return (
    <InsightTable
      title="Performance & Adoption"
      subtitle="Benchmarks on market traction, user satisfaction, and customer feedback across core and specialty product lines."
      data={tabData}
      metrics={tableColumns}
      rowIdentifier="competitor"
      actions={actions}
    />
  );
}

export default PerformanceAdoption;
